import type { ComponentProps } from 'react';

type TechdocsMermaidProps = Pick<
  ComponentProps<
    typeof import('backstage-plugin-techdocs-addon-mermaid').Mermaid
  >,
  'lightConfig' | 'darkConfig'
>;

/**
 * Theme-aware Mermaid settings for TechDocs. Use lightConfig/darkConfig (not a
 * single config) so diagrams stay readable in both Backstage palette modes.
 */
export const techdocsMermaidLightConfig: NonNullable<
  TechdocsMermaidProps['lightConfig']
> = {
  theme: 'forest',
  themeVariables: {
    lineColor: '#212121',
    primaryTextColor: '#212121',
    secondaryTextColor: '#424242',
    tertiaryTextColor: '#616161',
  },
};

export const techdocsMermaidDarkConfig: NonNullable<
  TechdocsMermaidProps['darkConfig']
> = {
  theme: 'dark',
  themeVariables: {
    lineColor: '#e0e0e0',
    primaryTextColor: '#f5f5f5',
    secondaryTextColor: '#e0e0e0',
    tertiaryTextColor: '#bdbdbd',
    mainBkg: '#424242',
    nodeBorder: '#bdbdbd',
    clusterBkg: '#383838',
    titleColor: '#ffffff',
    edgeLabelBackground: '#303030',
    textColor: '#f5f5f5',
  },
};

export const techdocsMermaidProps: TechdocsMermaidProps = {
  lightConfig: techdocsMermaidLightConfig,
  darkConfig: techdocsMermaidDarkConfig,
};
